import React from 'react'
import BannerTitles from '../../molecules/bannerTitles/bannerTitles'
import ContentSomeTips from '../contentSomeTips/contentSomeTips'
import SectionChallenges from '../sectionChallenges/sectionChallenges'

const ContentChallenges = () => {
  return (
    <>
      <BannerTitles section={'challenges'} />
      <SectionChallenges />
      <ContentSomeTips />
    </>
  )
}

export default ContentChallenges
